import React, { useCallback, useState } from "react";
import { Routes, Route, Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Footer from "../components/layout/Footer";
import ErrorBoundary from "../components/common/ErrorBoundary";
import { 
  FaTachometerAlt, 
  FaBox, 
  FaChartBar, 
  FaWarehouse,
  FaShoppingCart,
  FaTools,
  FaCog,
  FaSignOutAlt,
  FaUser,
  FaMoneyBillWave,
  FaBars,
  FaTimes
} from "react-icons/fa";
import "../styles/pages/Dashboard.css";

// Importar páginas desde la nueva estructura
import DashboardHomePage from "./sidebar/DashboardHomePage";
import PedidosPage from "./sidebar/PedidosPage";
import ReportesPage from "./sidebar/ReportesPage";
import StockLocalPage from "./sidebar/StockLocalPage";
import TallerPage from "./sidebar/TallerPage";
import SettingsPage from "./sidebar/SettingsPage";
// import FinancialTrackingPage from "./sidebar/FinancialTrackingPage"; // ELIMINADO: funcionalidad payment_tracking removida
// import CommissionManagement from "../components/sidebar/CommissionManagement"; // ELIMINADO: módulo comisiones removido

function Dashboard() {
  const location = useLocation();
  const { user, logout, hasModule } = useAuth();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Definir todos los módulos disponibles con sus permisos
  const allMenuItems = [
    { icon: FaTachometerAlt, label: "Dashboard", path: "/dashboard", module: "dashboard" }, // Requiere permiso
    { icon: FaBox, label: "Pedidos", path: "/dashboard/pedidos", module: "pedidos" },
    { icon: FaChartBar, label: "Reportes", path: "/dashboard/reportes", module: "reportes" },
    { icon: FaWarehouse, label: "Stock local", path: "/dashboard/stock-local", module: "stock" },
    { icon: FaTools, label: "Taller", path: "/dashboard/taller", module: "taller" },
    // { icon: FaMoneyBillWave, label: "Comisiones", path: "/dashboard/comisiones", module: "comisiones" } // ELIMINADO: módulo comisiones removido
  ];

  // Filtrar menú según permisos del usuario
  const menuItems = allMenuItems.filter(item => 
    item.module === null || hasModule(item.module)
  );

  const handleLogout = useCallback(() => {
    logout();
  }, [logout]);

  const isActivePath = useCallback((path) => {
    return location.pathname === path;
  }, [location.pathname]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className="dashboard-container">
      {/* Mobile Menu Toggle Button */}
      <button className="mobile-menu-toggle" onClick={toggleSidebar}>
        {isSidebarOpen ? <FaTimes /> : <FaBars />}
      </button>

      {/* Overlay for mobile */}
      {isSidebarOpen && <div className="sidebar-overlay" onClick={closeSidebar}></div>}

      {/* Sidebar */}
      <div className={`sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-header">
          <h3 className="brand-title">DORMO DECO</h3>
          {user && (
            <div className="user-info" style={{ 
              padding: '10px', 
              borderTop: '1px solid rgba(255,255,255,0.1)',
              marginTop: '10px',
              fontSize: '0.85rem',
              color: 'rgba(255,255,255,0.7)'
            }}>
              <FaUser style={{ marginRight: '5px' }} />
              {user.username || user.user_id}
            </div>
          )}
        </div>
        
        <div className="sidebar-menu">
          {menuItems.map((item, index) => {
            const IconComponent = item.icon;
            return (
              <Link
                key={index}
                to={item.path}
                className={`menu-item ${isActivePath(item.path) ? 'active' : ''}`}
                onClick={closeSidebar}
              >
                <IconComponent className="menu-icon" />
                <span className="menu-label">{item.label}</span>
              </Link>
            );
          })}
        </div>

        <div className="sidebar-footer">
          {/* Configuración - solo para usuarios con permiso */}
          {hasModule('configuracion') && (
            <Link to="/dashboard/settings" className="menu-item" onClick={closeSidebar}>
              <FaCog className="menu-icon" />
              <span className="menu-label">Configuración</span>
            </Link>
          )}
          <div className="menu-item" onClick={() => { closeSidebar(); handleLogout(); }}>
            <FaSignOutAlt className="menu-icon" />
            <span className="menu-label">Logout</span>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">

        <div className="content-area">
          <Routes>
            <Route path="/" element={<ErrorBoundary key="dashboard-home"><DashboardHomePage /></ErrorBoundary>} />
            <Route path="pedidos" element={<ErrorBoundary key="pedidos"><PedidosPage /></ErrorBoundary>} />
            <Route path="reportes" element={<ErrorBoundary key="reportes"><ReportesPage /></ErrorBoundary>} />
            <Route path="stock-local" element={<ErrorBoundary key="stock-local"><StockLocalPage /></ErrorBoundary>} />
            <Route path="taller" element={<ErrorBoundary key="taller"><TallerPage /></ErrorBoundary>} />
            {/* ELIMINADA: Ruta /finanzas (funcionalidad payment_tracking removida) */}
            {/* ELIMINADO: módulo comisiones removido
            <Route 
              path="comisiones" 
              element={
                hasModule('finanzas') ? (
                  <CommissionManagement />
                ) : (
                  <div style={{ padding: '40px', textAlign: 'center' }}>
                    <h2>🔒 Acceso Denegado</h2>
                    <p>No tienes permisos para acceder a esta sección.</p>
                  </div>
                )
              } 
            />
            */}
            <Route 
              path="settings" 
              element={
                hasModule('configuracion') ? (
                  <SettingsPage />
                ) : (
                  <div style={{ padding: '40px', textAlign: 'center' }}>
                    <h2>🔒 Acceso Denegado</h2>
                    <p>No tienes permisos para acceder a esta sección.</p>
                  </div>
                )
              } 
            />
          </Routes>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Dashboard;
